import React, { useContext, useEffect, useRef, useState } from "react";
import { animated, useSpring } from "@react-spring/three";
import { useGLTF } from "@react-three/drei";
import CurrentContext from "./CurrentContext";
import useSetMaterialFinish from "./useTextureCustom";
import { handleExportGLTF } from "./utils/jsHelpers";
import { useControls } from "leva";
import { Deg0, Deg90CCW } from "./utils/AnimaonSprings";
import { ChromeMaterial } from "../../constants/productConfiguratorConstants";

export default function Model_camanoUpdated() {
  const { nodes, materials, scene } = useGLTF("models/camano_updated.glb");
  const [finishes, setFinishes] = useState({});
  const [tileFinishes, setTileFinishes] = useState({});

  const {
    grill,
    setGrill,
    siding,
    setSiding,
    door,
    setDoor,
    secondDoor,
    colorScheme,
    setcolorScheme,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    umbrellHole,
    setUmbrellHole,
    bottleOpener,
    setBottleOpener,
    sideBurner,
    refrigerator,
    refrigeratorType,
    setRefrigeratorType,
    animation,
    tileColorScheme,
    setTileColorScheme,
    sink,
    groutColor,
    setGroutColor,
  } = useContext(CurrentContext);

  useEffect(() => {
    if (siding === "Quartzite") {
      if (colorScheme === "Sandstone Tan SR12") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-sandstone-tan.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-sandstone-tan.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
      if (colorScheme === "Misty Gray SR16") {
        setFinishes({
          diffuseMap: "../textures/big/quartzite-misty-gray.jpg",
          displacementMap: null,
          normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
          normalScale: [0.3, 0.3],
          repeat: [8, 8],
        });
      }
    } else if (siding === "Faux Rock") {
      if (colorScheme === "Gray") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-gray.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
      if (colorScheme === "Brown") {
        setFinishes({
          diffuseMap: "../textures/big/fauxrock-brown.jpg",
          aoMap: "../textures/big/bbq_faux_brick_ao.jpg",
          normalMap: "../textures/big/faux_brick_normal.png",
          normalScale: [1, 1],
        });
      }
    } else if (siding === "No Siding") {
      setFinishes({
        diffuseMap: "../textures/big/no-siding-1k.jpeg",
        displacementMap: null,
        // normalMap: "../textures/big/normal_quartzite-misty-gray.jpg",
        normalScale: [1, 1],
        repeat: [5, 5],
        // aoMap1: refrigerator ? '../textures/big/san_jaun_qurtize_base_with_fridge_ao.jpg' : '../textures/big/san_jaun_qurtize_base_without_fridge_ao.jpg'
      });
    }
    {
      if (tileColorScheme === "Chocolate") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-chocolate.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#928272",
        });
      }
      if (tileColorScheme === "Civic Sand") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-civic-sand.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#e5e3dec7",
        });
      }
      if (tileColorScheme === "Notable beige") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-notable-beige.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#eeebe5",
        });
      }
      if (tileColorScheme === "Park Lane Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-park-lane-gray.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#c6ccd4",
        });
      }
      if (tileColorScheme === "Union smoke") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-union-smoke.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#8c95a2",
        });
      }
      if (tileColorScheme === "Iron Gray") {
        setTileFinishes({
          diffuseMap: "../textures/big/tile-iron-gray.jpg",
          displacementMap: null,
          normalMap: null,
          roughness: 0.8,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
      if (tileColorScheme === "No Tile") {
        setTileFinishes({
          diffuseMap: "../textures/big/no-siding-1k.jpeg",
          displacementMap: null,
          normalMap: null,
          repeat: [3.424, 3.424],
          rotation: 90,
        });
        setGroutColor({
          color: "#818084",
        });
      }
    }
  }, [siding, colorScheme, tileColorScheme]);

  useSetMaterialFinish(materials.siding, finishes, setLoading);

  useSetMaterialFinish(materials.frame, groutColor, setLoading);

  useSetMaterialFinish(materials.island_top, tileFinishes, setLoading);

  const { rotation_Grill } = useSpring({
    rotation_Grill: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 500 : 0,
  });

  const { rotation_Side_burner } = useSpring({
    rotation_Side_burner: animation ? Deg90CCW : Deg0,
    config: { duration: 1000 },
    delay: animation ? 0 : 500,
  });

  return (
    <group dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.skirting.geometry}
        material={materials.siding}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['15"_sink_1'].geometry}
        material={materials.aluminium}
        visible={sink ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes['15"_sink_2'].geometry}
        material={materials.crome}
        visible={sink ? true : false}
      />

      {/* grill-30_agnus */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.grill_30_agnus.geometry}
        material={materials.brushed_ss}
        visible={grill === '30" Angus' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.agnus_button_light.geometry}
          material={materials.button_led}
          position={[-0.388, 0.889, 0.415]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.agnus_indicator_alpha.geometry}
          material={materials.label}
          position={[-0.002, 0, 0.193]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.agnus_knob_logo.geometry}
          material={materials.label}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.agnus_screw.geometry}
          material={materials.crome}
          position={[-0.038, 0.755, -0.141]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.agnus_tag.geometry}
          material={materials.tag}
          position={[-0.231, 0.891, 0.415]}
          rotation={[0.008, 0, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.angus_wire.geometry}
          material={materials.wire}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.grill_30_agnus_wire_part.geometry}
          material={materials.wire}
          position={[0, -0.001, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.grill_30_agnus_wire_part_2.geometry}
          material={materials.aluminium}
          position={[0, -0.001, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.grill_rod.geometry}
          material={materials.brushed_ss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.grill_rod_2.geometry}
          material={materials.crome}
        />
        <animated.group
          position={[-0.033, 1.1, 0.032]}
          rotation={rotation_Grill}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.grill_side_frame.geometry}
            material={materials.brushed_ss}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.glass.geometry}
              material={materials.glass}
              position={[-0.004, 0.129, 0.25]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.handle_mid.geometry}
              material={materials.crome}
              position={[0, -0.348, -0.194]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.handle_side.geometry}
              material={materials.crome}
              position={[0, -0.348, -0.194]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.temp_logo.geometry}
              material={materials.tag}
              position={[-0.005, 0.12, 0.244]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.temp_logo_base.geometry}
              material={materials.aluminium}
              position={[-0.005, 0.109, 0.236]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.temp_logo_frame.geometry}
              material={materials.crome}
              position={[-0.005, 0.125, 0.247]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.temp_logo_inner_frame.geometry}
              material={materials.aluminium}
              position={[-0.005, 0.129, 0.25]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.top.geometry}
              material={materials.brushed_ss}
              position={[0, -0.348, -0.194]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.top_inner.geometry}
              material={materials.brushed_ss}
              position={[0, -0.348, -0.194]}
            />
          </mesh>
        </animated.group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.inner_grill.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.logo_frame.geometry}
          material={materials.crome}
        />
      </mesh>

      {/* 38"_brahma */}
      <group visible={grill === '38" Brahma' ? true : false}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_brahma'].geometry}
          material={materials.brushed_ss}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_base_front.geometry}
            material={materials.brushed_ss}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_buffer.geometry}
            material={materials.buffer}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_grill.geometry}
            material={materials.crome}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_grill_handle.geometry}
            material={materials.black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_grill_rod.geometry}
            material={materials.brushed_ss}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_grill_rod_2.geometry}
            material={materials.crome}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_knob_indicator.geometry}
            material={materials.knob_indicator}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_knob_logo.geometry}
            material={materials.label}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_light.geometry}
            material={materials.light}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_logo.geometry}
            material={materials.label}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_logo_1.geometry}
            material={materials.label}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_net.geometry}
            material={materials.net}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_net_back.geometry}
            material={materials.aluminium}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_screw.geometry}
            material={materials.crome}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_tag.geometry}
            material={materials.tag}
          />
          <animated.group
            position={[-0.04, 1.101, 0.026]}
            rotation={rotation_Grill}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.brahma_top_side_frame.geometry}
              material={materials.brushed_ss}
              scale={1.017}
            >
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_glass.geometry}
                material={materials.glass}
                position={[0, 0.126, 0.251]}
                scale={0.984}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_handle_mid.geometry}
                material={materials.crome}
                position={[0.04, -1.108, -0.037]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_handle_side.geometry}
                material={materials.crome}
                position={[0.04, -1.108, -0.037]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_inner.geometry}
                material={materials.brushed_ss}
                position={[0.04, -1.108, -0.037]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_temp.geometry}
                material={materials.tag}
                position={[0, 0.117, 0.245]}
                scale={0.984}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_temp_base.geometry}
                material={materials.aluminium}
                position={[0, 0.106, 0.238]}
                scale={0.984}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_temp_frame.geometry}
                material={materials.aluminium}
                position={[0, 0.122, 0.248]}
                scale={0.984}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_temp_inner_frame.geometry}
                material={materials.aluminium}
                position={[0, 0.126, 0.251]}
                scale={0.984}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_top.geometry}
                material={materials.brushed_ss}
                position={[0.04, -1.108, -0.037]}
              />
            </mesh>
          </animated.group>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_wire.geometry}
            material={materials.wire}
            position={[0, 0, -0.764]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_wire_part.geometry}
            material={materials.wire}
            position={[0, -0.001, 0]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.brahma_wire_part_2.geometry}
            material={materials.aluminium}
            position={[0, -0.001, 0]}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.button_light_3.geometry}
            material={materials.button_led}
            position={[-0.501, 0.888, 0.416]}
          />
        </mesh>
      </group>

      {/* grill-30_bull_griddle */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.bull_griddle.geometry}
        material={materials.brushed_ss}
        visible={grill === '30" Bull Griddle Head' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_alpha.geometry}
          material={materials.label}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_burner.geometry}
          material={materials.brushed_ss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_knob_indicator.geometry}
          material={materials.knob_indicator}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_knob_logo.geometry}
          material={materials.label}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_knob_plane.geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_knob_plate.geometry}
          material={materials.brushed_ss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_knobs.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_logo.geometry}
          material={materials.tag}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_logo_2.geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bull_griddle_side_screw.geometry}
          material={materials.crome}
        />
        <animated.group
          position={[-0.038, 1.057, -0.063]}
          rotation={rotation_Grill}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.bull_griddle_top.geometry}
            material={materials.brushed_ss}
            scale={0.994}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.bull_griddle_handle_mid.geometry}
              material={materials.crome}
              position={[0.042, -1.054, 0.096]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.bull_griddle_handle_side.geometry}
              material={materials.crome}
              position={[0.042, -1.054, 0.096]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.bull_griddle_screw.geometry}
              material={materials.crome}
              position={[0.042, -1.054, 0.096]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.bull_griddle_top_side_frame.geometry}
              material={materials.brushed_ss}
            />
          </mesh>
        </animated.group>
      </mesh>

      {/* grill-30_lonestar_grill_head */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.lonestar_grill.geometry}
        material={materials.brushed_ss}
        visible={grill === '30" Lonestar' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_base_front.geometry}
          material={materials.brushed_ss}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_buffer.geometry}
          material={materials.buffer}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_button_light.geometry}
          material={materials.button_led}
          position={[-0.389, 0.888, 0.415]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_indicator_alpha.geometry}
          material={materials.label}
          position={[-0.002, 0, 0]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_knob_indicator.geometry}
          material={materials.knob_indicator}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_knob_logo.geometry}
          material={materials.label}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_light.geometry}
          material={materials.light}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_screw.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_stove_knob.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.lonestar_tag.geometry}
          material={materials.tag}
          position={[-0.224, 0.89, 0.416]}
          rotation={[-0.026, 0, 0]}
        />
        <animated.group
          position={[-0.039, 1.1, 0.033]}
          rotation={rotation_Grill}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.lonestar_top_side_frame.geometry}
            material={materials.brushed_ss}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_handle_side.geometry}
              material={materials.crome}
              position={[0.039, -1.107, -0.033]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_temp_base.geometry}
              material={materials.aluminium}
              position={[0, 0.117, 0.235]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_temp_frame.geometry}
              material={materials.crome}
              position={[0, 0.133, 0.246]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_temp_glass.geometry}
              material={materials.glass}
              position={[0, 0.137, 0.249]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_temp_inner_frame.geometry}
              material={materials.aluminium}
              position={[0, 0.137, 0.249]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_temp_logo.geometry}
              material={materials.tag}
              position={[0, 0.128, 0.243]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_top.geometry}
              material={materials.brushed_ss}
              position={[0.039, -1.107, -0.033]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.lonestar_top_inner.geometry}
              material={materials.brushed_ss}
              position={[0.039, -1.107, -0.033]}
            />
          </mesh>
        </animated.group>
      </mesh>

      {refrigeratorType !== "None" ? (
        <>
          {refrigeratorType === "Outdoor Rated Fridge" && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["brahma-siding_with_standard_fridge"].geometry}
                material={materials.siding}
                visible={grill === '38" Brahma' ? true : false}
              />

              <mesh
                castShadow
                receiveShadow
                geometry={nodes.siding_with_outdoor_fridge.geometry}
                material={materials.siding}
                visible={grill === '38" Brahma' ? false : true}
              />
            </>
          )}

          {refrigeratorType === "Standard Fridge" && (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes["brahma-siding_with_outdoor_fridge"].geometry}
                material={materials.siding}
                visible={grill === '38" Brahma' ? true : false}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.siding_with_standard_fridge.geometry}
                material={materials.siding}
                visible={grill === '38" Brahma' ? false : true}
              />
            </>
          )}
        </>
      ) : (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.siding_without_fridge.geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? false : true}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["brahma-siding_without_fridge"].geometry}
            material={materials.siding}
            visible={grill === '38" Brahma' ? true : false}
          />
        </>
      )}

      {/* 38"_double_door */}
      <group
        scale={[0.937, 1, 1]}
        visible={door === '38" Double Door' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_1'].geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_2'].geometry}
          material={materials.black_aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_handle'].geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_double_door_logo'].geometry}
          material={materials.tag}
        />
      </group>

      {/* bottle_opener */}
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.bottle_opener.geometry}
        material={materials.aluminium}
        visible={bottleOpener ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.bottle_opener_logo.geometry}
          material={materials.tag}
        />
      </mesh>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_door"].geometry}
        material={materials.aluminium}
        visible={door === '30" Double Door' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-double_door_logo"].geometry}
          material={materials.tag}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-double_handle"].geometry}
          material={materials.crome}
        />
      </mesh>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.net_frame.geometry}
        material={materials.net_frame}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.side_net.geometry}
        material={materials.side_net}
      />
      
      <group visible={secondDoor === "Trash Drawer" ? true : false}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.trash_drawer_1.geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.trash_drawer_2.geometry}
          material={materials.black_aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.trash_drawer_handle.geometry}
          material={materials.crome}
        />
      </group>

      {/* 30" Double Door */}

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.double_drawer_handle.geometry}
        material={materials.crome}
        visible={secondDoor === "Double Drawer" ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_1.geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_2.geometry}
           material={materials.black_aluminium}
        />
      </mesh>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.side_burner.geometry}
        material={materials.brushed_ss}
        position={[0, -0.008, 0]}
        visible={sideBurner ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.burner_knob_logo.geometry}
          material={materials.logo}
          position={[0.78, 1.036, 0.225]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.burnur_black_part.geometry}
          material={materials.black}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.burnur_grill.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.burnur_inner_part.geometry}
          material={materials.burnur_inner_part}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.burnur_strips.geometry}
          material={materials.black}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.side_burner_knob.geometry}
          material={materials.crome}
        />
        <animated.group
          position={[0.734, 1.001, -0.197]}
          rotation={rotation_Side_burner}
        >
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.side_burner_top.geometry}
            material={materials.brushed_ss}
          >
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.side_burner_handle.geometry}
              material={materials.crome}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.side_burnur_logo.geometry}
              material={materials.tag}
              position={[-0.734, -1.001, 0.197]}
              scale={[0.937, 1, 1]}
            />
            <mesh
              castShadow
              receiveShadow
              geometry={nodes.side_burner_top_logo_frame.geometry}
              material={materials.aluminium}
              position={[0.156, 0.004, 0.344]}
              rotation={[-0.502, 0, 0]}
              scale={1.063}
            />
          </mesh>
        </animated.group>
      </mesh>

      {grill === '38" Brahma' ? (
        <>
          {tileColorScheme === "No Tile" ? (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_side_with_brahma.geometry}
                material={materials['metal_side_with_30"_grill']}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_side_top_with_brahma.geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_metal_side_top_with_sink.geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
            </>
          ) : (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_island_top_without_sink.geometry}
                material={materials.frame}
                visible={sink ? false : true}
              >
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top_2.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top_strip_2.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top_tiles_2.geometry}
                  material={materials.island_top}
                />
              </mesh>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.brahma_island_top_with_sink.geometry}
                material={materials.frame}
                visible={sink ? true : false}
              >
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top.geometry}
                  material={materials.island_top}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top_grouting.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.brahma_island_top_strip.geometry}
                  material={materials.frame}
                />
              </mesh>
            </>
          )}
        </>
      ) : (
        <>
          {tileColorScheme === "No Tile" ? (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes['metal_side_with_30"_grill'].geometry}
                material={materials['metal_side_with_30"_grill']}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes['metal_side_top_with_30"_grill'].geometry}
                material={materials.island_top}
                visible={sink ? false : true}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.metal_side_top_with_sink.geometry}
                material={materials.island_top}
                visible={sink ? true : false}
              />
            </>
          ) : (
            <>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top_without_sink.geometry}
                material={materials.frame}
                visible={sink ? false : true}
              >
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_grouting_2.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_strip_2.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_tiles_2.geometry}
                  material={materials.island_top}
                />
              </mesh>

              <mesh
                castShadow
                receiveShadow
                geometry={nodes.island_top_with_sink.geometry}
                material={materials.frame}
                visible={sink ? true : false}
              >
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_grouting.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_strip.geometry}
                  material={materials.frame}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.island_top_tiles.geometry}
                  material={materials.island_top}
                />
              </mesh>
            </>
          )}
        </>
      )}
      <group
        visible={door === '38" Door/Drawer Combo' ? true : false}
        scale={[0.935, 1, 1]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_1'].geometry}
          material={materials.aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_2'].geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes['38"_doordrawer_3'].geometry}
          material={materials.aluminium}
        />
      </group>

      {door === '30" Door/Propane Drawer Combo' && (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_1"].geometry}
            material={materials.aluminium}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes["door-door_propane_drawer_combo_2"].geometry}
            material={materials.black_aluminium}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.door_propane_drawer_combo_handle.geometry}
            material={materials.crome}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.door_propane_drawer_combo_logo.geometry}
            material={materials.tag}
          />
        </>
      )}

      <mesh
        castShadow
        receiveShadow
        geometry={nodes["door-double_drawer_door_combo"].geometry}
        material={materials.aluminium}
        visible={door === '30" Door/Drawer Combo' ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes["door-double_drawer_door_combo_logo"].geometry}
          material={materials.tag}
          scale={[0.937, 1, 1]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.double_drawer_door_combo_handle.geometry}
          material={materials.crome}
        />
      </mesh>

      {/* Outdoor Rated Fridge */}
      <group
        visible={refrigeratorType === "Outdoor Rated Fridge" ? true : false}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.outdoor_rated_fridge_1.geometry}
          material={materials.fridge}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.outdoor_rated_fridge_2.geometry}
          material={materials.crome}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.outdoor_rated_fridge_3.geometry}
          material={materials.black_aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.fridge_logo_2.geometry}
          material={materials.tag}
        />
      </group>
      {/* Standard Fridge */}
      <group visible={refrigeratorType === "Standard Fridge" ? true : false}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.fridge_1.geometry}
          material={materials.fridge}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.fridge_2.geometry}
          material={materials.black_aluminium}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.refrigerator_logo.geometry}
          material={materials.tag}
        />
      </group>

      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_1.geometry}
        material={materials.aluminium}
        visible={umbrellHole ? true : false}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.umbrella_hole_2.geometry}
        material={materials.black}
        visible={umbrellHole ? true : false}
      />
      {secondDoor === "Vertical Access Door" ? (
        <>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.vertical_access_door_1.geometry}
            material={materials.aluminium}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.vertical_access_door_2.geometry}
            material={materials.black}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.vertical_access_door_handle.geometry}
            material={materials.crome}
          />
        </>
      ) : null}
      <mesh castShadow receiveShadow geometry={nodes.plug.geometry} material={materials.plug} />
    </group>
  );
}
